export const RANK_COLORS: {[index: number]: string} = {
    1: "#FFFFFF",
    2: "#17d102",
    3: "#17d102",
    4: "#e3d807",
    5: "#e3d807",
    6: "#e3d807",
    7: "#e3d807",
    8: "#f58b0a",
    9: "#f58b0a",
    10: "#E02413",
}